export class User {

  constructor(id?: string, email?: string, name?: string, surname?: string, fullname?: string, roles?: string[], act?: string, delegation_id?: string) {
    this.id = id;
    this.email = email;
    this.name = name;
    this.surname = surname;
    this.fullname = fullname;
    this.act = act;
    this.delegation_id= delegation_id;
    this.roles = roles;
  }

  public id: string;
  public email: string;
  public name: string;
  public surname: string;
  public fullname: string;
  public act: string;
  public delegation_id: string;
  public roles: string[];
  public isEnabled: boolean;
}
